import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as endPoints from '../assets/js/endpoints';
import PageTitle from '../components/PageTitle';
import {
  Container,
  Paper,
  Box,
  TextField,
  Button,
  useTheme,
  Autocomplete,
} from '@mui/material';
import { PERMISSION_LABELS } from '../constants/permissionLabels';
import { useNotification } from '../assets/contexts/notificationContext';
import { Helmet } from 'react-helmet';

export default function CreateRole() {
  const { id } = useParams();
  const [name, setName] = useState('');
  const [permissions, setPermissions] = useState([]);
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();
  const theme = useTheme();
  const { showNotification } = useNotification();

  const getRole = async roleId => {
    if (roleId) {
      const role = await endPoints.getRol(roleId);
      setName(role.rol.name);
      setPermissions(await endPoints.getPermissions());
      setSelected(role.permissions.map(p => p.id));
    } else {
      setPermissions(await endPoints.getPermissions());
    }
  };

  useEffect(() => {
    getRole(id);
  }, []);

  const data = permissions.map(p => ({
    value: p.id,
    label: PERMISSION_LABELS[p.name] || p.name,
  }));

  const getStyles = option => ({
    fontWeight:
      data.map(d => d.label).indexOf(option.label) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  });

  const handleGuardar = async e => {
    e.preventDefault();
    try {
      if (id) {
        await endPoints.deleteRol(id);
      }
      await endPoints.createRol(name, selected);
      showNotification(id ? 'Rol actualizado' : 'Rol creado', 'success');
      navigate('/admin/roles');
    } catch (_err) {
      showNotification('Error guardando rol', 'error');
    }
  };

  return (
    <>
      <Helmet>
        <title>{id ? 'Actualizar Rol' : 'Crear Rol'} | CES</title>
      </Helmet>
      <Container sx={{ mt: 5, paddingBottom: 2, mb: 2 }}>
        <Paper sx={{ p: 3, maxWidth: 400, mx: 'auto' }}>
            <Box component="form" onSubmit={handleGuardar} sx={{ display: 'grid', gap: 2 }}>
              <PageTitle>Rol</PageTitle>
              <TextField label="Nombre" value={name} onChange={e => setName(e.target.value)} required />
              <Autocomplete
                multiple
                options={data}
                value={data.filter(option => selected.includes(option.value))}
                onChange={(_event, newValue) => setSelected(newValue.map(option => option.value))}
                getOptionLabel={option => option.label}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                renderOption={(props, option) => (
                  <li {...props} style={getStyles(option)}>
                    {option.label}
                  </li>
                )}
                renderInput={params => (
                  <TextField {...params} label="Permisos" required />
                )}
              />
              <Button type="submit" variant="contained" sx={{ mx: 'auto' }}>Guardar</Button>
            </Box>
        </Paper>
      </Container>
    </>
  );
}
